export default "__VITE_ASSET__PAAnhtaV__"